import { Pipe, PipeTransform } from '@angular/core';
import { convertTimeToDisplayFormat } from '@shared/utils';

@Pipe({
  name: 'customTimeDisplay',
})
export class CustomTimeDisplayPipe implements PipeTransform {
  transform(time: string): string {
    return convertTimeToDisplayFormat(time);
  }
}
